<app-splash-screen *ngIf="loader"></app-splash-screen>
<router-outlet></router-outlet>

